import { AxiosResponse } from 'axios';
import Request from './Request';

export default class WalletApi {
  public static getWalletToken(): Promise<AxiosResponse> {
    return Request.get('/v1/account/get_wallet_token');
  }
}
